/**
 * État physique du pied de chaîne d'un OF. Miroir du back.
 *
 * Calculé automatiquement par le back. Jamais modifié à la main depuis le front.
 * `null` = pas de PDC nécessaire (nomenclature sans article `withPiedDeChaine`)
 * OU OF annulé.
 */
export enum PdcStatus {
  A_PREPARER = "A_PREPARER",
  EN_COURS_PREPA = "EN_COURS_PREPA",
  PRET = "PRET",
  EN_CONSOMMATION = "EN_CONSOMMATION",
  A_REINTEGRER = "A_REINTEGRER",
  REINTEGRE = "REINTEGRE",
}

export enum PdcStatusLibelle {
  A_PREPARER = "À préparer",
  EN_COURS_PREPA = "Prépa en cours",
  PRET = "PDC prêt",
  EN_CONSOMMATION = "En consommation",
  A_REINTEGRER = "À réintégrer",
  REINTEGRE = "Réintégré",
}

export type PdcChipState =
  | "warn"
  | "pending"
  | "valid"
  | "primary"
  | "enabled";

/**
 * Mapping PdcStatus → vl-chips state pour l'affichage des badges.
 */
export const PDC_STATUS_CHIP_STATE: Record<PdcStatus, PdcChipState> = {
  [PdcStatus.A_PREPARER]: "warn",
  [PdcStatus.EN_COURS_PREPA]: "pending",
  [PdcStatus.PRET]: "valid",
  [PdcStatus.EN_CONSOMMATION]: "primary",
  [PdcStatus.A_REINTEGRER]: "warn",
  [PdcStatus.REINTEGRE]: "enabled",
};

/**
 * Icône Material par statut.
 */
export const PDC_STATUS_ICON: Record<PdcStatus, string> = {
  [PdcStatus.A_PREPARER]: "inventory_2",
  [PdcStatus.EN_COURS_PREPA]: "hourglass_top",
  [PdcStatus.PRET]: "check_circle",
  [PdcStatus.EN_CONSOMMATION]: "autorenew",
  [PdcStatus.A_REINTEGRER]: "u_turn_left",
  [PdcStatus.REINTEGRE]: "done_all",
};
